//新闻时间计算(**分钟/小时/天前)
//调用：computationTime.init($(".time"),"data-time");
//liuxu
//滚动热搜词
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD
        define(['jquery'], factory);
    } else if (typeof exports === 'object') {
        // Node, CommonJS
        module.exports = factory(require('jquery'));
    } else {
        // 浏览器全局变量(root 即 window)
        root.computationTime = factory(root.jQuery);
    }
}(this, function ($) {
    var computationTime = {
        jsDateDiff: function (strtime) {
            if (!strtime) {
                return false;
            }
            var new_str = strtime.replace(/:/g, '-');
            new_str = new_str.replace(/ /g, '-');
            var arr = new_str.split("-");
            var datum = new Date(Date.UTC(arr[0], arr[1] - 1, arr[2], arr[3] - 8, arr[4], arr[5]));
            var publishTime = datum.getTime();
            var d_minutes, d_hours, d_days;
            var timeNow = parseInt(new Date().getTime() / 1000);
            var d;
            d = timeNow - parseInt(publishTime / 1000);
            d_days = parseInt(d / 86400);
            d_hours = parseInt(d / 3600);
            d_minutes = parseInt(d / 60);
            if (d_days > 0 && d_days < 4) {
                return d_days + "天前";
            } else if (d_days <= 0 && d_hours > 0) {
                return d_hours + "小时前";
            } else if (d_hours <= 0 && d_minutes > 0) {
                return d_minutes + "分钟前";
            } else if (d_minutes == 0) {
                return "刚刚";
            } else {
                var s = new Date(parseInt(publishTime));
                // s.getFullYear()+"年";
                return (s.getMonth() + 1) + "月" + s.getDate() + "日";
            }
        },
        init: function ($timecontainer, strtime) {
            var T = this;
            $timecontainer.each(function () {
                $(this).html(T.jsDateDiff($(this).attr(strtime)))
            })
        }
    }
    return computationTime;
}))



//////////////////
// WEBPACK FOOTER
// ./static/v4/js/computation-time.js
// module id = 341d21852521831d4cb3
// module chunks = 1